import { useState } from 'react';
import { LocalDepartments } from '../../../../../../types/nafLocations';
import { findNearbyCenters } from './NafCenters.utils';

interface UseLocationSortOptions {
  onSuccess?: () => void;
}

interface UseLocationSortResult {
  sortedByLocation: boolean;
  sortedCenters: LocalDepartments[];
  isFindingLocation: boolean;
  locationError: string | null;
  handleSortByLocation: () => Promise<void>;
  dismissError: () => void;
  reset: () => void;
}

export const useLocationSort = ({ onSuccess }: UseLocationSortOptions): UseLocationSortResult => {
  const [sortedByLocation, setSortedByLocation] = useState(false);
  const [sortedCenters, setSortedCenters] = useState<LocalDepartments[]>([]);
  const [isFindingLocation, setIsFindingLocation] = useState(false);
  const [locationError, setLocationError] = useState<string | null>(null);

  const handleSortByLocation = async () => {
    setIsFindingLocation(true);
    setLocationError(null);

    try {
      const nearbyCenters = await findNearbyCenters();

      if (nearbyCenters.length === 0) {
        setLocationError('Kunne ikke finne nærmeste senter.');
        return;
      }

      setSortedCenters(nearbyCenters);
      setSortedByLocation(true);
      onSuccess?.();
    } catch (err) {
      setLocationError(err instanceof Error ? err.message : 'En feil oppstod ved henting av lokasjon.');
    } finally {
      setIsFindingLocation(false);
    }
  };

  const dismissError = () => setLocationError(null);

  const reset = () => {
    setSortedByLocation(false);
    setSortedCenters([]);
    setLocationError(null);
  };

  return {
    sortedByLocation,
    sortedCenters,
    isFindingLocation,
    locationError,
    handleSortByLocation,
    dismissError,
    reset,
  };
};
